import React, { useEffect } from 'react';
import { Icon, Message } from 'semantic-ui-react';

const VARIANT_CONFIG = {
  success: {
    title: 'Listo',
    icon: 'check circle',
    iconColor: '#15803D',
    accent: '#22C55E',
    background: 'linear-gradient(180deg, #FFFFFF 0%, #F0FDF4 100%)',
    borderColor: '#BBF7D0',
  },
  error: {
    title: 'Atencion',
    icon: 'warning circle',
    iconColor: '#B91C1C',
    accent: '#EF4444',
    background: 'linear-gradient(180deg, #FFFFFF 0%, #FEF2F2 100%)',
    borderColor: '#FECACA',
  },
  info: {
    title: 'Importante',
    icon: 'info circle',
    iconColor: '#1D4ED8',
    accent: '#3B82F6',
    background: 'linear-gradient(180deg, #FFFFFF 0%, #EFF6FF 100%)',
    borderColor: '#BFDBFE',
  },
};

const SemanticUiReactSnackbar = ({ variant = 'info', children, visible, setVisible }) => {
  useEffect(() => {
    if (!visible) return undefined;
    const timer = setTimeout(() => setVisible(false), 5000);
    return () => clearTimeout(timer);
  }, [visible, children, setVisible]);

  if (!visible) return null;

  const config = VARIANT_CONFIG[variant] || VARIANT_CONFIG.info;

  return (
    <div
      style={{
        position: 'fixed',
        left: '50%',
        bottom: 24,
        transform: 'translateX(-50%)',
        width: 'min(560px, calc(100vw - 32px))',
        zIndex: 1000,
      }}
    >
      <Message
        style={{
          margin: 0,
          borderRadius: 20,
          border: `1px solid ${config.borderColor}`,
          borderTop: `4px solid ${config.accent}`,
          background: config.background,
          boxShadow: '0 24px 70px rgba(15, 23, 42, 0.16)',
          padding: '18px 20px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
          <div
            style={{
              width: 42,
              height: 42,
              borderRadius: 14,
              background: '#FFFFFF',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 10px 24px rgba(15, 23, 42, 0.08)',
              flexShrink: 0,
            }}
          >
            <Icon name={config.icon} style={{ color: config.iconColor, margin: 0, fontSize: 20 }} />
          </div>

          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 800, fontSize: 16, color: '#111827', marginBottom: 4 }}>
              {config.title}
            </div>
            <div style={{ color: '#4B5563', fontSize: 15, lineHeight: 1.5 }}>{children}</div>
          </div>

          <button
            type="button"
            onClick={() => setVisible(false)}
            style={{
              border: 'none',
              background: 'transparent',
              color: '#6B7280',
              cursor: 'pointer',
              padding: 4,
              lineHeight: 1,
              flexShrink: 0,
            }}
            aria-label="Cerrar mensaje"
          >
            <Icon name="close" style={{ margin: 0 }} />
          </button>
        </div>
      </Message>
    </div>
  );
};

export default SemanticUiReactSnackbar;
